<template>
  <b-modal id="modal-galeria-multimedia-album-imagen" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"
          ><i class="fa fa-image"></i>
          Galeria de Imágenes
        </span>
      </div>
    </template>
    <!--Galeria de fotos - Contenido-->
    <div class="container-fluid flex-grow-1">
      <b-row>
        <b-col md="12 p-xl-4">
          <center>
            <h3 v-if="procesoElectoralMultimediaAlbum.tipoParametroMultimedia != null && procesoElectoralMultimediaAlbum.tipoParametroMultimedia == 'Img_Voluntario'" class="display-sl-section-title">
              <i class="fa fa-users fa-fw justify-content-center mr-2"></i>
              Fotos de Voluntarios
            </h3>
            <h3 v-if="procesoElectoralMultimediaAlbum.tipoParametroMultimedia != null && procesoElectoralMultimediaAlbum.tipoParametroMultimedia == 'Img_Local_Votacion'" class="display-sl-section-title">
              <i class="fa fa-building fa-fw justify-content-center mr-2"></i>
              Fotos de Locales de Votación
            </h3>
          </center>
          <div class="mb-3">
            <i class="fa fa-paperclip fa-fw justify-content-center mr-2"></i>
            {{ procesoElectoralMultimediaAlbum.descripcion }}
          </div>
          <center>
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="imagen in procesoElectoralMultimediaAlbum.imagenes" :key="imagen.procesoElectoralMultimediaImagenId" :style="{ width: 'auto', paddingBottom: '20px' }">
                <img
                  v-img="{
                    group: 'v-img-gallery-' + procesoElectoralMultimediaAlbum.procesoElectoralMultimediaAlbumId,
                    src: apiResource(imagen.rutaArchivo),
                  }"
                  :src="apiResource(imagen.rutaArchivoThumb)"
                  alt=""
                  height="300"
                />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </center>
        </b-col>
      </b-row>
    </div>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
    </template>
  </b-modal>
</template>

<style scoped>
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px;
}
</style>

<!--<style src="@/vendor/libs/v-img/v-img.scss" lang="scss"></style>-->

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//import "swiper/css/swiper.css";

import Vue from "vue";
import VueImg from "v-img";
Vue.use(VueImg, {
  altAsTitle: true,
  thumbnails: true,
});

export default {
  name: "galeria-multimedia-album-imagen",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    procesoElectoralMultimediaAlbumId: {
      type: Number,
    },
  },
  data: () => ({
    mostrarModal: true,
    procesoElectoralMultimediaAlbum: {
      procesoElectoralMultimediaAlbumId: null,
      procesoElectoral: "",
      localVotacionNombre: "",
      localVotacionDireccion: "",
      tipoParametroMultimedia: "",
      descripcion: "",
      imagenes: [],
    },
    swiperOption: {
      slidesPerView: "auto",
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    vImgOptions: {
      group: "v-img-gallery",
    },
  }),
  computed: {},
  methods: {
    handleModalClose: async function(event) {
      if (event) {
        event.preventDefault();
      }

      /*var resp = await this.sweetConfirm("¿Desea cerrar esta ventana?");
      if (resp) {
        this.mostrarModal = false;
      }*/

      this.mostrarModal = false;
    },
    doSave: async function() {
      if (!(await this.sweetConfirm("¿Desea guardar los datos?"))) {
        return;
      }

      if (!this.isFormValid("frm-add-edit-proceso-electoral-multimedia-album")) {
        return this.sweetAlert("Hay campos con valores incorrectos. Revise los datos ingresados.");
      }

      this.estaGuardando = false;
      this.mostrarModal = false;
    },
    fetchAlbumMultimediaImagenes: function(procesoElectoralMultimediaAlbumId) {
      if (procesoElectoralMultimediaAlbumId) {
        this.$http
          .get(this.apiRoute("MultimediaElectoralProcess", "GetProcesoElectoralMultimediaAlbumImagenes"), {
            params: {
              ProcesoElectoralMultimediaAlbumId: procesoElectoralMultimediaAlbumId,
            },
          })
          .then(function(response) {
            this.procesoElectoralMultimediaAlbum = response.body.data;
          });
      }
    },
  },
  watch: {
    mostrarModal: function(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted: function() {
    this.mostrarModal = this.value;
    this.procesoElectoralMultimediaAlbum.procesoElectoralMultimediaAlbumId = this.procesoElectoralMultimediaAlbumId;
    this.initParsley();
    this.fetchAlbumMultimediaImagenes(this.procesoElectoralMultimediaAlbum.procesoElectoralMultimediaAlbumId);
  },
  destoyed: function() {},
};
</script>
